import Vue from 'vue';

// \u00A0 equivalente à &nbsp;
Vue.filter('white-space', (value) => value || '\u00A0');
